export const isValidWebLink = (text: string) => {
  /* eslint-disable-next-line */
  return new RegExp(/^(http(s):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/g).test(
    text,
  );
};
